<template>
  <div class="search-group">
    <b-input
      v-model="valueInner"
      name="inputSearch"
      class="search-items"
      :placeholder="placeholder"
      autofocus
      debounce="800"
    />
    <span
      class="icon-delete"
      @click="cleanInput"
    ><i class="fas fa-times" /></span>
    <label
      name="labelSearch"
      for="inputSearch"
      class="fas fa-search search icon"
    />
  </div>
</template>

<style lang="scss">
///search
.search-items {
  color: #5d5b5b;
  padding-left: calc(0.05rem + 0.5rem + 1rem + 0.2rem);
  padding-right: calc(0.1rem + 0.1rem + 1rem + 0.2rem);
  &:focus {
    border-color: rgba(24, 28, 33, 0.1);
  }
}

.search-group {
  position: relative;

  & .icon {
    position: absolute;
    padding: 0.05rem;
    left: 0.5rem;
    top: calc(
      50% - 0.5em
    ); /* Keep icon in center of input, regardless of the input height */
    color: #7c7a7a;
  }
  & .icon-delete {
    position: absolute;
    padding: 0.05rem;
    right: 0.5rem;
    top: calc(50% - 0.7em);
    cursor: pointer;
    color: #7c7a7a;
  }
}

.search-group label.search-placeholder {
  top: calc(50% - 0.6rem);
  padding-left: 1.5rem;
  text-align: top;
  font-weight: 500;
  color: rgba(124, 122, 122, 0.4117647058823529);
}
</style>

<script>
export default {
  name: 'InputSearch',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Busca por palavra chave',
    },
  },
  data() {
    return {
      valueInner: this.value,
    }
  },
  watch: {
    valueInner: function sendToParent(value) {
      this.$emit('input', value)
    },
  },
  methods: {
    cleanInput() {
      this.valueInner = null
      this.$emit('clean', this.valueInner)
    },
  },
}
</script>
